<p>choose-property works!</p>
